'use client';

import PdfFile, { PdfFileProps } from 'components/gruenland/organisms/pdf';
import { TasticProps } from 'frontastic/tastics/types';

const YggdrasilPdfTastic = ({ data }: TasticProps<PdfFileProps>) => {
  return <PdfFile file={data.file} />;
};

export default YggdrasilPdfTastic;
